export default __webpack_public_path__ + "static/media/agro-int.97160515.png";